
import { defineComponent, PropType, ref } from 'vue'
import Services from '@/services/todos'
import { TodoItem } from '@/types'

export default defineComponent({
	name: 'TodoDetails',

	props: {
		id: {
			type: [Number, String],
			required: true
		},
	},

	data() {
		return {
			todo: {} as TodoItem,
			loading: true
		}
	},

	mounted() {
		Services.getTodo(+this.id)
		.then(res => {
			this.todo = res.data
			console.log(res.data)
		})
		.catch(rej => {
			console.log(rej)
		})
		.then(() => this.loading = false )
	}
})
